import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      setDevToken(data.mock_reset_token);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll send a reset link to your email."
      footer={<Link to="/login" className="text-slate-900 font-semibold underline" data-testid="link-back-login">Back to login</Link>}>
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-3">
            If an account exists for {email}, a reset link is on its way.
          </div>
          {devToken && (
            <div className="text-xs bg-slate-100 border rounded-md p-3">
              <p className="font-semibold text-slate-500 mb-1">DEV MODE (email is mocked):</p>
              <Link to={`/reset-password?token=${devToken}`} className="text-slate-900 underline break-all" data-testid="dev-reset-link">
                Continue to reset password →
              </Link>
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{error}</div>}
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
